// composables/useAdminCheck.ts
import { ref, onMounted } from "vue";
import { fetchAuthSession } from "aws-amplify/auth";

const isUserInAdminGroup = ref(false);

const checkAdminGroup = async () => {
  try {
    const { tokens } = await fetchAuthSession();
    const userGroups = tokens?.accessToken.payload["cognito:groups"] || [];
    let groups: string[] = [];

    // Payload can be of many types so must do this check
    if (Array.isArray(userGroups)) {
      groups = userGroups.map((group) => String(group));
    } else if (typeof userGroups === "string") {
      groups = [userGroups];
    } else if (typeof userGroups === "object") {
      groups = Object.values(userGroups).map((group) => String(group));
    }

    isUserInAdminGroup.value = groups.includes("Admin");
  } catch (error) {
    console.error("Error retrieving user groups:", error);
    isUserInAdminGroup.value = false;
  }
};

const useAdminCheck = () => {
  onMounted(() => {
    checkAdminGroup();
  });

  return {
    isUserInAdminGroup,
    checkAdminGroup,
  };
};

export { useAdminCheck, checkAdminGroup, isUserInAdminGroup };
